import { Dialog, Box, Typography, IconButton, Stack, Button as MuiButton, useTheme } from '@mui/material';
import { IoClose } from 'react-icons/io5';
import { FiExternalLink } from 'react-icons/fi';
import { LuClock } from 'react-icons/lu';
import ReferralGiftIcon from '@/assets/icons/ReferralGiftIcon';
import { useGetCurrentUser } from 'apis/user/hook';

interface ReferralModalProps {
  open: boolean;
  onClose: () => void;
}

const ReferralModal = ({ open, onClose }: ReferralModalProps) => {
  const theme = useTheme();
  const { data: currentUser } = useGetCurrentUser();
  const email = currentUser?.email ?? '—';

  return (
    <Dialog
      open={open}
      onClose={onClose}
      sx={{ '& .MuiDialog-paper': { maxWidth: '768px', width: '100%' } }}
      fullWidth
      slotProps={{
        paper: {
          sx: {
            borderRadius: '8px',
            p: 3
          }
        }
      }}
    >
      {/* Header */}
      <Box display='flex' alignItems='center' justifyContent='space-between'>
        <Box display='flex' alignItems='center' gap={1}>
          <ReferralGiftIcon size={24} />
          <Typography fontWeight={500} fontSize={20}>
            Referral Program
          </Typography>
        </Box>

        <IconButton sx={{ p: 0 }} onClick={onClose}>
          <IoClose />
        </IconButton>
      </Box>

      <Box mt={3} sx={{ border: '1px solid #ECECEC', p: 2, borderRadius: '10px', bgcolor: '#FAFAFA' }}>
        {/* Top Card */}
        <Box display='flex' justifyContent='space-between' alignItems='center' borderRadius='12px'>
          <Typography fontSize='16px' color='text.secondary' sx={{ maxWidth: '70%' }}>
            Earn{' '}
            <Typography color='black' component='span' fontWeight={600}>
              $50
            </Typography>{' '}
            for every business you refer that becomes an active customer. Share your unique link and start earning.
          </Typography>

          <MuiButton
            variant='outlined'
            href='https://referral.kickcall.ai/'
            target='_blank'
            rel='noopener noreferrer'
            startIcon={<FiExternalLink />}
            sx={{
              px: 3,
              borderRadius: '999px',
              textTransform: 'none',
              fontWeight: 600
            }}
          >
            Affiliate Dashboard
          </MuiButton>
        </Box>

        {/* Blue Info Section */}
        <Box
          sx={{
            backgroundColor: '#E8F0FE',
            borderRadius: '12px',
            p: 2,
            mt: 2
          }}
        >
          <Stack spacing={2}>
            <Box display='flex' alignItems='center' gap={1}>
              <LuClock color={theme.palette.primary.main} />
              <Typography color='text.secondary' fontSize='16px'>
                Your referrals, payouts, and tax forms live in our affiliate portal.
              </Typography>
            </Box>

            {/* Email Box */}
            <Box
              sx={{
                backgroundColor: '#fff',
                border: '1px solid #E5E7EB',
                borderRadius: '10px',
                p: 2
              }}
            >
              <Typography fontSize='12px' color='text.secondary' sx={{ mb: 0.5 }}>
                Sign in using your email
              </Typography>

              <Typography fontWeight={500}>{email}</Typography>
            </Box>
          </Stack>
        </Box>
      </Box>
    </Dialog>
  );
};

export default ReferralModal;
